// eslint-disable-next-line import/prefer-default-export
export const normalizeString = (str: string) => {
  // Defensive: callers may pass a non-string (e.g. a React node from a Select
  // option's `children`) \u2014 return it unchanged rather than throwing on
  // `.normalize`. Strings (including '') are normalized as before.
  if (typeof str !== 'string') return str;
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
};
